import Handlebars from '@sparta.global.vendors/handlebars';
import Utility from '@sparta.sales.utilities/module-utils-utility/dist/es6.js';
import Module, { registerModuleClass } from '@sparta.global.utilities/sparta-module-utility/dist/es6.js';
import spartaValidationFramework from '@sparta.global.utilities/sparta-validation-framework-utility/dist/es6.js';
import $ from '@sparta.global.vendors/jquery';
import _ from '@sparta.global.vendors/lodash';
import { currencyInput } from '@sparta.global.helpers/text-inputs-helper/dist/es6.js';
import { link } from '@sparta.global.helpers/sparta-helper/dist/es6.js';

const Template$2 = Handlebars.template({"1":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "<section id=\"affordabilityCalculatorHomeLoans\">\r\n  <div class=\"row calculate\">\r\n"
    + ((stack1 = container.invokePartial(lookupProperty(partials,"calculate-panel"),depth0,{"name":"calculate-panel","data":data,"indent":"    ","helpers":helpers,"partials":partials,"decorators":container.decorators})) != null ? stack1 : "")
    + ((stack1 = container.invokePartial(lookupProperty(partials,"calculate-results-panel"),depth0,{"name":"calculate-results-panel","data":data,"indent":"    ","helpers":helpers,"partials":partials,"decorators":container.decorators})) != null ? stack1 : "")
    + "  </div>\r\n</section>\r\n";
},"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return ((stack1 = lookupProperty(helpers,"with").call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"local") : depth0),{"name":"with","hash":{},"fn":container.program(1, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":1,"column":0},"end":{"line":8,"column":9}}})) != null ? stack1 : "");
},"usePartial":true,"useData":true});
const renderTemplate$2 = function (data, options) {
  return Template$2(data, options);
};

const Template$1 = Handlebars.template({"1":function(container,depth0,helpers,partials,data) {
    var lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "    "
    + container.escapeExpression((lookupProperty(helpers,"currencyInput")||(depth0 && lookupProperty(depth0,"currencyInput"))||container.hooks.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),depth0,{"name":"currencyInput","hash":{},"data":data,"loc":{"start":{"line":6,"column":4},"end":{"line":6,"column":26}}}))
    + "\r\n";
},"3":function(container,depth0,helpers,partials,data) {
    var lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "            <a href=\"javascript:void(0);\" class=\""
    + container.escapeExpression(container.lambda((depth0 != null ? lookupProperty(depth0,"class") : depth0), depth0))
    + " spa-btn spa-btn--"
    + container.escapeExpression(container.lambda((depth0 != null ? lookupProperty(depth0,"size") : depth0), depth0))
    + " spa-btn--secondary\"\r\n                    id=\""
    + container.escapeExpression(container.lambda((depth0 != null ? lookupProperty(depth0,"id") : depth0), depth0))
    + "\"\r\n                    role=\"button\">\r\n              <span class=\"button-text\">"
    + container.escapeExpression(container.lambda((depth0 != null ? lookupProperty(depth0,"content") : depth0), depth0))
    + "</span>\r\n              <span class=\"ada-hidden\"></span><span class=\"spin\"></span>\r\n            </a>\r\n";
},"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    var stack1, helper, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "\r\n<div class=\"column small-10 small-centered medium-3 medium-uncentered\">\r\n  <div class=\"form\">\r\n"
    + ((stack1 = lookupProperty(helpers,"each").call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"inputs") : depth0),{"name":"each","hash":{},"fn":container.program(1, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":5,"column":4},"end":{"line":7,"column":13}}})) != null ? stack1 : "")
    + "    <div class=\"form-submit\" data-submit-text-change ="
    + container.escapeExpression(((helper = (helper = lookupProperty(helpers,"data-submit-text-change") || (depth0 != null ? lookupProperty(depth0,"data-submit-text-change") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"data-submit-text-change","hash":{},"data":data,"loc":{"start":{"line":8,"column":54},"end":{"line":8,"column":81}}}) : helper)))
    + ">\r\n"
    + ((stack1 = lookupProperty(helpers,"with").call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"calculateButton") : depth0),{"name":"with","hash":{},"fn":container.program(3, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":9,"column":8},"end":{"line":16,"column":17}}})) != null ? stack1 : "")
    + "    </div>\r\n    <p class=\"disclaimer-text disclaimer-text__bottom\">"
    + container.escapeExpression(((helper = (helper = lookupProperty(helpers,"calculateButtonDisclaimer") || (depth0 != null ? lookupProperty(depth0,"calculateButtonDisclaimer") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"calculateButtonDisclaimer","hash":{},"data":data,"loc":{"start":{"line":18,"column":55},"end":{"line":18,"column":84}}}) : helper)))
    + "</p>\r\n  </div>\r\n</div>\r\n";
},"useData":true});
const renderTemplate$1 = function (data, options) {
  options = options || {};options.helpers = options.helpers || {};options.partials = options.partials || {};
  options.helpers = {...options.helpers, ..._moduleConfig.helpers };
  options.partials = {...options.partials, ..._moduleConfig.partials };
  return Template$1(data, options);
};

const Template = Handlebars.template({"1":function(container,depth0,helpers,partials,data) {
    var stack1, helper, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "<div class=\"column small-11 small-centered medium-5 medium-uncentered\">\r\n  <div class=\"outer-card\">\r\n    <div class=\"grantMessage\">\r\n      <div style=\"padding-bottom:10px\"> <img\r\n        src=\""
    + container.escapeExpression(((helper = (helper = lookupProperty(helpers,"houseIcon") || (depth0 != null ? lookupProperty(depth0,"houseIcon") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"houseIcon","hash":{},"data":data,"loc":{"start":{"line":7,"column":13},"end":{"line":7,"column":26}}}) : helper)))
    + "\"\r\n        height=\"31.5px\"\r\n        width=\"34\"\r\n        alt=\"\"\r\n        aria-hidden=\"true\"\r\n      /></div>\r\n      <div>"
    + ((stack1 = ((helper = (helper = lookupProperty(helpers,"description") || (depth0 != null ? lookupProperty(depth0,"description") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"description","hash":{},"data":data,"loc":{"start":{"line":13,"column":11},"end":{"line":13,"column":28}}}) : helper))) != null ? stack1 : "")
    + "</div>\r\n    </div>\r\n    <p class=\"disclaimer-text\">"
    + ((stack1 = ((helper = (helper = lookupProperty(helpers,"topDisclaimer") || (depth0 != null ? lookupProperty(depth0,"topDisclaimer") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"topDisclaimer","hash":{},"data":data,"loc":{"start":{"line":15,"column":31},"end":{"line":15,"column":50}}}) : helper))) != null ? stack1 : "")
    + "</p>\r\n    <div class=\"inner-card in-out\">\r\n      <div class=\"virtual-DOM-Container\" id=\"result-panel\">\r\n        <div id=\"result-panel-partial\" class=\"hide\" type=\"text/x-handlebars-template\">\r\n            <div class=\"virtual-DOM\">\r\n              <h2 class=\"estHomePrice\" tabindex=\"0\">"
    + container.escapeExpression(((helper = (helper = lookupProperty(helpers,"estimatedHomePrice") || (depth0 != null ? lookupProperty(depth0,"estimatedHomePrice") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"estimatedHomePrice","hash":{},"data":data,"loc":{"start":{"line":20,"column":52},"end":{"line":20,"column":74}}}) : helper)))
    + "<br>\r\n                <p class=\"homeprice\">"
    + container.escapeExpression(((helper = (helper = lookupProperty(helpers,"estimatedHomePriceText") || (depth0 != null ? lookupProperty(depth0,"estimatedHomePriceText") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"estimatedHomePriceText","hash":{},"data":data,"loc":{"start":{"line":21,"column":37},"end":{"line":21,"column":63}}}) : helper)))
    + "</p>\r\n              </h2>\r\n              <div class=\"interestRateAPR\">\r\n                  <p class=\"normal-text disclaimer-text monthlyIncPara\">"
    + ((stack1 = ((helper = (helper = lookupProperty(helpers,"mortgagePayment") || (depth0 != null ? lookupProperty(depth0,"mortgagePayment") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"mortgagePayment","hash":{},"data":data,"loc":{"start":{"line":24,"column":72},"end":{"line":24,"column":93}}}) : helper))) != null ? stack1 : "")
    + "</p>\r\n                  <p class=\"normal-text interest-rate aprPara\">"
    + container.escapeExpression(((helper = (helper = lookupProperty(helpers,"interestRate") || (depth0 != null ? lookupProperty(depth0,"interestRate") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"interestRate","hash":{},"data":data,"loc":{"start":{"line":25,"column":63},"end":{"line":25,"column":79}}}) : helper)))
    + "</p>\r\n              </div>\r\n              <p class=\"normal-text margin-half downPaymentPara\">"
    + container.escapeExpression(((helper = (helper = lookupProperty(helpers,"mortgageTerms") || (depth0 != null ? lookupProperty(depth0,"mortgageTerms") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"mortgageTerms","hash":{},"data":data,"loc":{"start":{"line":27,"column":65},"end":{"line":27,"column":82}}}) : helper)))
    + "</p>\r\n            </div>\r\n        </div>\r\n      </div>\r\n      <div class=\"cursorColor editButton\">\r\n        <div class=\"arrowImg\"></div>\r\n        "
    + ((stack1 = ((helper = (helper = lookupProperty(helpers,"edit") || (depth0 != null ? lookupProperty(depth0,"edit") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"edit","hash":{},"data":data,"loc":{"start":{"line":33,"column":8},"end":{"line":33,"column":18}}}) : helper))) != null ? stack1 : "")
    + "\r\n      </div>\r\n      <div class=\"downPaymentEdit inActive\">\r\n        <div class=\"inputDownPayment\">\r\n"
    + ((stack1 = lookupProperty(helpers,"each").call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"inputs") : depth0),{"name":"each","hash":{},"fn":container.program(2, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":37,"column":10},"end":{"line":39,"column":19}}})) != null ? stack1 : "")
    + "        </div>\r\n        <button class=\"updateDownPayment cursorColor\" tabindex=\"0\">Update</button>\r\n      </div>\r\n    </div>\r\n    <div class=\"inner-card error-response inActive\">\r\n      <span>"
    + ((stack1 = ((helper = (helper = lookupProperty(helpers,"no-response") || (depth0 != null ? lookupProperty(depth0,"no-response") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"no-response","hash":{},"data":data,"loc":{"start":{"line":45,"column":12},"end":{"line":45,"column":29}}}) : helper))) != null ? stack1 : "")
    + "</span><br><br>\r\n      "
    + ((stack1 = ((helper = (helper = lookupProperty(helpers,"learnMore") || (depth0 != null ? lookupProperty(depth0,"learnMore") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"learnMore","hash":{},"data":data,"loc":{"start":{"line":46,"column":6},"end":{"line":46,"column":21}}}) : helper))) != null ? stack1 : "")
    + "\r\n    </div>\r\n    <div class=\"phone-link\">"
    + ((stack1 = ((helper = (helper = lookupProperty(helpers,"infoMsgWithPhone") || (depth0 != null ? lookupProperty(depth0,"infoMsgWithPhone") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"infoMsgWithPhone","hash":{},"data":data,"loc":{"start":{"line":48,"column":28},"end":{"line":48,"column":50}}}) : helper))) != null ? stack1 : "")
    + "\r\n      <span class=\"number-link\">\r\n        <a class=\"sc-phone-number link\" tabindex=\"-1\" href=\"javascript:void(1);\" id=\""
    + container.escapeExpression(((helper = (helper = lookupProperty(helpers,"ID") || (depth0 != null ? lookupProperty(depth0,"ID") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"ID","hash":{},"data":data,"loc":{"start":{"line":51,"column":85},"end":{"line":51,"column":91}}}) : helper)))
    + "\">"
    + ((stack1 = ((helper = (helper = lookupProperty(helpers,"text") || (depth0 != null ? lookupProperty(depth0,"text") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"text","hash":{},"data":data,"loc":{"start":{"line":51,"column":93},"end":{"line":51,"column":105}}}) : helper))) != null ? stack1 : "")
    + "</a>\r\n    </span>\r\n    </div>\r\n    <div class=\"form prequalified-card\">\r\n      "
    + container.escapeExpression(((helper = (helper = lookupProperty(helpers,"prequalifiedText") || (depth0 != null ? lookupProperty(depth0,"prequalifiedText") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"prequalifiedText","hash":{},"data":data,"loc":{"start":{"line":55,"column":6},"end":{"line":55,"column":26}}}) : helper)))
    + "\r\n      <div class=\"pre-qualified-btn\">\r\n        "
    + ((stack1 = ((helper = (helper = lookupProperty(helpers,"prequalifiedBtn") || (depth0 != null ? lookupProperty(depth0,"prequalifiedBtn") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"prequalifiedBtn","hash":{},"data":data,"loc":{"start":{"line":57,"column":8},"end":{"line":57,"column":29}}}) : helper))) != null ? stack1 : "")
    + "\r\n      </div>\r\n    </div>\r\n  </div>\r\n  <p class=\"disclaimer-text disclaimer-text__bottom\">"
    + ((stack1 = ((helper = (helper = lookupProperty(helpers,"bottomDisclaimer") || (depth0 != null ? lookupProperty(depth0,"bottomDisclaimer") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"bottomDisclaimer","hash":{},"data":data,"loc":{"start":{"line":61,"column":53},"end":{"line":61,"column":75}}}) : helper))) != null ? stack1 : "")
    + "</p>\r\n\r\n  <p id=\"disclaimer-panel\"  class=\"disclaimer-text disclaimer-text__bottom additional-disclaimer virtual-footer-DOM\">\r\n      "
    + ((stack1 = ((helper = (helper = lookupProperty(helpers,"additionalDisclaimerPre") || (depth0 != null ? lookupProperty(depth0,"additionalDisclaimerPre") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"additionalDisclaimerPre","hash":{},"data":data,"loc":{"start":{"line":65,"column":6},"end":{"line":65,"column":35}}}) : helper))) != null ? stack1 : "")
    + "<span class=\"interestAPR\">"
    + ((stack1 = ((helper = (helper = lookupProperty(helpers,"disclaimerSection") || (depth0 != null ? lookupProperty(depth0,"disclaimerSection") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"disclaimerSection","hash":{},"data":data,"loc":{"start":{"line":65,"column":61},"end":{"line":65,"column":84}}}) : helper))) != null ? stack1 : "")
    + "</span>"
    + ((stack1 = ((helper = (helper = lookupProperty(helpers,"additionalDisclaimerPost") || (depth0 != null ? lookupProperty(depth0,"additionalDisclaimerPost") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"additionalDisclaimerPost","hash":{},"data":data,"loc":{"start":{"line":65,"column":91},"end":{"line":65,"column":121}}}) : helper))) != null ? stack1 : "")
    + "\r\n  </p>\r\n</div>\r\n";
},"2":function(container,depth0,helpers,partials,data) {
    var lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "            "
    + container.escapeExpression((lookupProperty(helpers,"currencyInput")||(depth0 && lookupProperty(depth0,"currencyInput"))||container.hooks.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),depth0,{"name":"currencyInput","hash":{},"data":data,"loc":{"start":{"line":38,"column":12},"end":{"line":38,"column":34}}}))
    + "\r\n";
},"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return ((stack1 = lookupProperty(helpers,"with").call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"rightContent") : depth0),{"name":"with","hash":{},"fn":container.program(1, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":2,"column":0},"end":{"line":69,"column":9}}})) != null ? stack1 : "");
},"useData":true});
const renderTemplate = function (data, options) {
  options = options || {};options.helpers = options.helpers || {};options.partials = options.partials || {};
  options.helpers = {...options.helpers, ..._moduleConfig.helpers };
  options.partials = {...options.partials, ..._moduleConfig.partials };
  return Template(data, options);
};

// Import templates & helpers
var _moduleConfig = {
  "name": "@sparta.home-loans.modules/affordability-calculator-module",
  "version": "3.0.1",
  "id": "affordability-calculator-module",
  "containerID": "homeLoansAffordabilityCalculatorModule",
  "moduleName": "home-loans-affordability-calculator-module",
  "semantic": true,
  "superModule": false,
  "viewPort": ["small", "medium", "large"],
  "tag": "div",
  "nameSpace": "affordability-calculator-module",
  "data": {
    "init": "affordabilityCalculatorJS",
    "options": {}
  },
  "moduleParams": [{
    "name": "scope",
    "type": "string",
    "default": "",
    "description": ""
  }],
  "layout": "layout",
  "render": function (context) {
    return renderTemplate$2(context, {
      "helpers": {
        currencyInput,
        link
      },
      "partials": {
        "calculate-panel": renderTemplate$1,
        "calculate-results-panel": renderTemplate
      }
    });
  },
  "template": renderTemplate$2,
  "partials": {
    "calculate-panel": renderTemplate$1,
    "calculate-results-panel": renderTemplate
  },
  "helpers": {
    currencyInput,
    link
  },
  "dependencies": {
    "@sparta.sales.utilities/module-utils-utility": "^1.0.0",
    "@sparta.global.helpers/select-helper": "^1.0.0",
    "@sparta.global.helpers/sparta-helper": "^1.0.0",
    "@sparta.global.helpers/text-inputs-helper": "^1.0.0",
    "@sparta.global.utilities/sparta-module-utility": "^1.0.0",
    "@sparta.global.utilities/sparta-style-token-utility": "^1.0.0",
    "@sparta.global.utilities/sparta-validation-framework-utility": "^1.0.0",
    "@sparta.global.vendors/handlebars": "^4.7.7",
    "@sparta.global.vendors/jquery": "^3.2.1",
    "@sparta.global.vendors/lodash": "^4.17.21"
  },
  "stores": []
};

/**
 *
 * @export
 * @class affordabilityCalculatorJS
 * @extends {Module}
 */
class affordabilityCalculatorJS extends Module {
  /**
   * Creates an instance of AffordabilityBudgetModule.
   * @param {Object} options Module option
   * @param {Object} context Module context
   */
  constructor(options, context) {
    super({
      ...options,
      context,
      config: _moduleConfig
    });
    this.affCalObj = {
      recalculateBtn: true,
      eventsBind: false
    };
    this.bindAllMethod = Utility.bindAllMethod.bind(this);
    this.bindAllMethod();
  }

  /**
   * @return {void}
   */
  init() {
    const {
      target,
      $target
    } = this.settings;
    $target.spartaInputs({
      validate: true
    });
    this.validationCore = spartaValidationFramework.fn.core;
    this.Validation = spartaValidationFramework.fn.core;
    // cache selector
    const $resultPanelPartial = $('#result-panel-partial');

    // extract partial
    const resultPanelSource = $resultPanelPartial.html();

    // compile template
    this.resultPanelTemplate = Handlebars.compile(resultPanelSource);

    // update result panel html
    const html = this.resultPanelTemplate({
      estimatedHomePrice: '$0',
      monthlyPITIAmount: '$0',
      interestRate: '',
      apr: '',
      downPayment: '$0',
      downpaymentPercentage: 20
    });
    this.$resultPanelPartialContent = $('#result-panel');
    this.$resultPanelPartialContent.html(html);
    const formValidations = {
      editDownPayment: {
        change: {
          customFunction: {
            parameters: {
              customFunction: this.validateDownPayment,
              includeElement: true
            },
            errorMessage: '<span class="errorMsg">Enter down payment equal to or > 5% of the estimated home price*.</span>' // Optional. Will override default error message.
          }
        }
      }
    };
    this.initializeValidation($target);
    this.validationCore.bindValidationRules(formValidations, true);

    // add event listener to the calculate and edit down payment buttons
    target.querySelector('.calculateBtn').addEventListener('click', this.calculatorValidate.bind(this, $target, this.validationCore));
    this.Events.sub('HOME_LOANS_AFFORDABILITY_CALCULATOR_SUBMIT', this.updateSpinner);
    this.toggleBasedOnCalculate('none');
    this.Events.sub('HOME_LOANS_AFFORDABILITY_RATES_REQUEST_SUCCESS', event => {
      const {
        data
      } = event;
      this.updateSpinner();
      this.ratesSuccess(data);
      this.emptyResults(!document.querySelector('.error-response').classList.contains('inActive'));
    });
    this.Events.sub('HOME_LOANS_AFFORDABILITY_RATES_REQUEST_FAILURE', this.ratesFailure.bind(this));
  }

  /**
   * @param {Object} showStatus object
   * @return {void}
   */
  toggleBasedOnCalculate(showStatus) {
    this.settings.$target.find('div.form.prequalified-card')[0].style.display = showStatus;
    this.settings.$target.find('p.normal-text.interest-rate')[0].style.display = showStatus;
    this.settings.$target.find('p.disclaimer-text.disclaimer-text__bottom.additional-disclaimer')[0].style.display = showStatus;
    document.querySelector('#homeAffordabilityDisclosures').style.display = showStatus;
    // eslint-disable-next-line no-extra-boolean-cast
    if (!!document.querySelector('#disclaimer-panel .dagger')) {
      document.querySelector('#disclaimer-panel .dagger').style.display = showStatus === 'none' ? showStatus : 'inline';
    }
  }

  /**
   * @param {Object} $element object
   * @return {void}
   */
  validateDownPayment($element) {
    // By default the $element is valid.
    const elementValue = this.currencyToNumber($element.val());
    const fivePercent = this.calcResponse.estimatedHomePrice / 100 * 5;
    const returnValue = elementValue > fivePercent && elementValue <= this.calcResponse.estimatedHomePrice;
    this.showingErrorMsg(returnValue);
    return returnValue;
  }

  /**
   * @param {Object} returnValue object
   * @return {void}
   */
  showingErrorMsg(returnValue) {
    const {
      target
    } = {
      ...this.settings
    };
    if (returnValue === true) {
      target.querySelector('.phone-link').style.display = 'none';
    } else {
      target.querySelector('.phone-link').style.display = 'block';
      target.querySelector('div.prequalified-card').style.display = 'none';
      target.querySelector('.prequalified-button-cs').style.display = 'block';
      this.Events.sub('HOME_LOANS_PHONE_NUMBER_REQUEST_SUCCESS', event => {
        const {
          data
        } = event;
        target.querySelector('.link').innerText(data.phoneNumber);
      });
    }
  }

  /**
   * @param {Object} $target object
   * @return {void}
   */
  initializeValidation($target) {
    this.validationRules = _.fromPairs(this.settings.$target.find('[data-validation-rules]').map(function rulesMap() {
      const $this = $(this);
      return [[$this.attr('id'), $this.data('validation-rules')]];
    }));
    this.validationCore.bindValidationRules(this.validationRules, true);

    // Separate handling of "required" validations
    $target.find('input[required]').each((index, input) => {
      const $input = $(input);
      $input.on('blur', () => {
        if (!$input.val()) {
          this.Validation.validateRequiredFields($input);
        }
      });
    });
  }

  /**
   * @param {Object} response object
   * @return {void}
   */
  ratesSuccess(response) {
    this.toggleBasedOnCalculate('block');
    this.calcResponse = {
      ...response.result
    };
    const {
      target
    } = {
      ...this.settings
    };
    this.populateResultAndDisclaimer(this.calcResponse);
    if (!this.affCalObj.eventsBind) {
      this.affCalObj.eventsBind = true;
      target.querySelector('.editButton').addEventListener('click', this.editDownPayment);
      target.querySelector('.updateDownPayment').addEventListener('click', this.updateDownPayment);
    }
    target.querySelector('#disclaimer-panel').style.display = 'block';
    document.querySelector('.editDownPaymentLink').classList.remove('disableBtn');
    target.querySelector('.estHomePrice').focus();
  }

  /**
   * @method scrollToHomeIcon
   * @desc Scroll to home icon with animation
   * @return {void}
   */
  scrollToHomeIcon() {
    const $grantMessage = this.settings.$target.find('.grantMessage');
    const {
      top
    } = {
      ...$grantMessage.offset()
    };
    const sizeSticky = this.Store.getData('currentMQ').viewport === 'small' ? 'small' : 'large';
    let offset = $('.spa-page-title').outerHeight();
    const $topTabNav = $(`#${sizeSticky}-tab-nav .spa-sticky`);
    if ($topTabNav.length > 0) {
      const topNavHeight = $($topTabNav).outerHeight();
      offset += sizeSticky === 'large' && topNavHeight <= 0 ? 60 : topNavHeight;
    }
    const animation = {
      scrollTop: top - offset
    };
    $('html, body').animate(animation, 1000);
  }

  /**
   * @param {Array} [data={}] array
   * @return {void}
   */
  populateResultAndDisclaimer(data = {}) {
    const {
      downpaymentPercentage,
      ahgeligibility
    } = {
      ...data
    };
    let {
      estimatedHomePrice,
      monthlyPITIAmount,
      interestRate,
      apr,
      downPayment
    } = {
      ...data
    };
    estimatedHomePrice = `$${this.currencyCommaSeperation(estimatedHomePrice)}`;
    interestRate = this.interestFloatVal(interestRate);
    apr = this.interestFloatVal(apr);
    monthlyPITIAmount = `$${this.currencyTrunc(monthlyPITIAmount)}`;
    const aprDate = new Date().toLocaleDateString();
    downPayment = `$${this.currencyCommaSeperation(downPayment)}`;
    const modifiedData = {
      ...data,
      estimatedHomePrice,
      interestRate,
      apr,
      monthlyPITIAmount,
      downPayment,
      downpaymentPercentage,
      aprDate
    };
    this.settings.$target.find('.interestAPR').text(`${interestRate}%, ${apr}% APR, on ${aprDate}`);
    const html = this.resultPanelTemplate(modifiedData);
    this.$resultPanelPartialContent.html(html);
    setTimeout(() => {
      if (ahgeligibility) {
        this.settings.$target.find('.grantMessage').show();
        this.scrollToHomeIcon();
      } else {
        this.settings.$target.find('.grantMessage').hide();
      }
    }, 200);
    this.affCalObj.calcResults.firstPassResultInputs = this.affCalObj.calcResults.firstPassResultInputs || data;
    const daggerLinks = document.querySelector('a.disclosures-dagger');
    daggerLinks.removeEventListener('click', this.animateScroll);
    daggerLinks.addEventListener('click', this.animateScroll);
  }

  /**
   * @method animateScroll
   * @return {void}
   * @desc Scroll to disclosure text with animation
   */
  animateScroll() {
    // spa page or not
    $('.route-all').length > 0 ? true : false; // eslint-disable-line

    let offset = $('.spa-page-title').outerHeight();
    const sizeSticky = this.Store.getData('currentMQ').viewport === 'small' ? 'small' : 'large';
    const $topTabNav = $(`#${sizeSticky}-tab-nav .spa-sticky`);
    if ($topTabNav.length > 0) {
      const topNavHeight = $($topTabNav).outerHeight();
      offset += sizeSticky === 'large' && topNavHeight <= 0 ? 60 : topNavHeight;
    }
    const $disclosureDetails = $('#disclaimer-panel');
    const {
      top
    } = {
      ...$disclosureDetails.offset()
    };
    const animation = {
      scrollTop: top - offset
    };
    $('html, body').animate(animation, 1000);
    setTimeout(() => {
      $(window).trigger('resize');
    }, 600);
  }

  /**
   * @return {void}
   */
  ratesFailure() {
    this.emptyResults(document.querySelector('.error-response').classList.contains('inActive'));
    this.updateSpinner();
    this.settings.target.querySelector('#disclaimer-panel').style.display = 'none';
  }

  /**
   * @return {void}
   */
  updateButtonText() {
    this.affCalObj.recalculateBtn = false;
    const calcBtn = this.settings.target;
    const recalculateText = calcBtn.querySelector('.form-submit').dataset.submitTextChange;
    calcBtn.querySelector('.button-text').innerText = recalculateText;
    calcBtn.querySelector('.calculateBtn').classList.add('recalculateBtn');
    calcBtn.querySelector('.spin').classList.add('reCalculateSpin');
  }

  /**
   * @return {void}
   */
  updateSpinner() {
    this.settings.target.querySelector('.spin').classList.toggle('spinner');
  }

  /**
   * @param {Object} $target object
   * @param {Object} validation object
   * @param {Object} event event
   * @return {void}
   * @memberof affordabilityCalculatorJS
   */
  calculatorValidate($target, validation, event) {
    event.preventDefault();
    const requiredFieldsValid = validation.validateRequiredFields($target.find('[required]:visible')); // trigger required field validation
    const valid = requiredFieldsValid && $target.find('.spa-error-form-input--validation[required]:visible').length === 0;
    if (!valid) {
      return;
    }
    const annualIncome = $target.find('#AGIhousehold').val();
    const monthlyDebt = $target.find('#monthlyDebtPayments').val();
    const postalCode = $target.find('#zip-code-input').val();
    const rateInputs = {
      postalCode
    };
    const debtToIncomeInputs = {
      annualIncome: this.currencyToNumber(annualIncome),
      monthlyDebt: this.currencyToNumber(monthlyDebt)
    };
    this.affCalObj.calcResults = {
      rateInputs,
      debtToIncomeInputs,
      firstPassResultInputs: null
    };
    this.affordableCost(this.affCalObj.calcResults);
    if (this.affCalObj.eventsBind) {
      const editDownPayment = $target.find('input#editDownPayment');
      const errorMsg = $target.find('div#editDownPayment_errorMessage');
      errorMsg.text('');
      editDownPayment.focus();
      editDownPayment.val('');
    }
    if (this.affCalObj.recalculateBtn) {
      this.updateButtonText();
    }
    const prequalURL = document.querySelector('#prequalified-button-id').href.split('/');
    // Destructuring - get 2nd element in array
    const [, url] = [...spaParams.siteParams.secureHost.split('//')];
    // Destructuring - setting 2nd position in array to url variable
    document.querySelector('#prequalified-button-id').href = [...prequalURL.slice(0, 2), url, ...prequalURL.slice(3)].join('/');
  }

  /**
   * @return {void}
   * @param {Object} calcResult object
   */
  affordableCost(calcResult) {
    this.Events.pub('HOME_LOANS_AFFORDABILITY_CALCULATOR_SUBMIT', calcResult);
  }

  /**
   * @return {void}
   */
  editDownPayment() {
    this.settings.$target.find('.downPaymentEdit').slideToggle('fast');
    document.querySelector('.arrowImg').classList.toggle('upArrow');
  }

  /**
   * @return {void}
   */
  updateDownPayment() {
    const $downPayment = this.settings.$target.find('input#editDownPayment');
    this.Validation.validateRequiredFields($downPayment, true);
    if (!this.validateDownPayment($downPayment)) {
      return;
    }
    const calcResult = this.affCalObj.calcResults;
    calcResult.firstPassResultInputs.downPayment = this.currencyToNumber($downPayment.val());
    calcResult.downPayment = this.currencyToNumber($downPayment.val());
    this.affordableCost(calcResult);
  }

  /**
   * @return {void}
   * @param {Object} money amount
   */
  currencyCommaSeperation(money) {
    return Math.round(money).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  }

  /**
   * @return {void}
   * @param {Object} monthlyPITIAmount amount
   */
  currencyTrunc(monthlyPITIAmount) {
    return Math.trunc(monthlyPITIAmount).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  }

  /**
   * @return {String} interest Rate
   * @param {Object} interestRate amount
   */
  interestFloatVal(interestRate) {
    return interestRate.toFixed(3).toString();
  }

  /**
   * @return {Number} number
   * @param {Object} currency amount
   */
  currencyToNumber(currency) {
    return Number.parseInt(currency.replace(/,/g, ''), 10);
  }

  /**
   * @return {void}
   * @param {Object} responseFlag flag
   */
  emptyResults(responseFlag) {
    if (responseFlag) {
      document.querySelector('.error-response').classList.toggle('inActive');
      document.querySelector('.in-out').classList.toggle('inActive');
    }
  }
}
registerModuleClass({
  moduleClass: affordabilityCalculatorJS,
  moduleConfig: _moduleConfig
});
const moduleConfig = _moduleConfig;

export { affordabilityCalculatorJS as default, moduleConfig };
